(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sellerHq', sellerHq);

    /* @ngInject */
    function sellerHq($sce, $rootScope) {
        var directive = {
            bindToController: true,
            templateUrl: 'seller-hq.tpl',
            controller: sellerHqCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.account = scope.vm.data.query[0].customs.account;
            scope.vm.abook = scope.vm.data.query[0].customs.abook;
            scope.vm.past_sales_years = scope.vm.data.query[0].customs.past_sales_years;
            if (angular.isDefined(scope.vm.data.query[0].customs.team)) {
                var teamTab = scope.vm.tabs.find(function(e) {
                    return e.id == 'team';
                });
                teamTab.disabled = false;
                scope.vm.team = scope.vm.data.query[0].customs.team;
                scope.vm.team.years = scope.vm.team.years.map(function(y) {
                    y.members = y.members.map(function(m) {
                        m.img = !m.photo.value ? $rootScope.globals.default.individualImg : m.photo.value.sizes.thumbnail.url;
                        if (!m.hq.goal.value) {
                            m.hq.goal.value = parseInt($rootScope.globals.site_options.seller_team_defaults.seller_default_goal);
                        }
                        return m;
                    });
                    return y;
                });
            }
            scope.vm.year = '0';
            scope.vm.giftPie = scope.$root.globals.site_options.shopping_cart_settings.giftPie;
            // if (scope.vm.currentTab == 'sales') {
            scope.getSales();
            // }
        }
    }

    /* @ngInject */
    function sellerHqCtrl($scope, $location, $filter, $window, $http) {
        $scope.vm.baseurl = baseurl;
        // $scope.vm.baseurl = 'http://pie.dev.limusdesign.com';

        $scope.vm.switchTab = switchTab;
        $scope.vm.teamTabSwitch = 'team-directory';
        var tabs = [];
        if (!$scope.$root.project_has_opt('layoutFF')) {
            tabs = [
                { title: 'Updates', id: 'updates', disabled: false },
                { title: 'Account', id: 'account', disabled: false },
                { title: 'Sales', id: 'sales', disabled: false },
                { title: 'Edit My Page', id: 'edit_my_page', disabled: false },
                { title: 'Team', id: 'team', disabled: true },
                { title: 'Toolkit', id: 'toolkit', disabled: false },
                { title: 'Address Book', id: 'address_book', disabled: false }
            ];
        } else {
            tabs = [
                { title: 'Updates', id: 'updates', disabled: false },
                { title: 'Sales', id: 'sales', disabled: false },
                { title: 'Toolkit', id: 'toolkit', disabled: false },
                { title: 'Edit My Page', id: 'edit_my_page', disabled: false },
                { title: 'Account', id: 'account', disabled: false },
                { title: 'Address Book', id: 'address_book', disabled: false },
                { title: 'Team', id: 'team', disabled: true }
            ];
        }

        // set active tab by query param, example: http://pie.com/seller/hq/aperitiv-rumkin/?tab=toolkit
        var searchObject = $location.search();
        // var foundInTabs = $filter('filter')(tabs, { 'id': searchObject.tab });

        var foundInTabs = tabs.filter(function(t) {
            return t.id === searchObject.tab;
        });

        if (Array.isArray(foundInTabs) && foundInTabs.length !== 0) {
            $scope.vm.currentTab = searchObject.tab;
        } else if (angular.isDefined($scope.$root.hqCurrentTab) && $scope.$root.hqCurrentTab)  {
            $scope.vm.currentTab = $scope.$root.hqCurrentTab;
        } else {
            $scope.vm.currentTab = tabs[0].id;
        }

        $scope.vm.tabs = tabs;

        function switchTab(tid) {
            if (tid == 'sales') {
                $scope.getSales();
            }
            if (tid == 'edit_my_page') {
                $location.url($location.url().replace('hq/',''));
            } else {
                $scope.vm.currentTab = tid;
            }
            $scope.$root.hqCurrentTab = tid;
        }

        $scope.requesting = false;

        $scope.downloadLink = function(data) {
            var bin = atob(data.file);
            var buf = new ArrayBuffer(bin.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != bin.length; ++i) {
                view[i] = bin.charCodeAt(i) & 0xFF;
            }
            var blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        $scope.ajaxIt = function(method, params, callback) {
            if ($scope.requesting) {
                return;
            }
            $scope.requesting = true;
            $http.post(ajaxurl, {
                action: 'pie_action',
                method: method,
                nonce: $scope.$root.stats.nonce,
                params: params
            }).then(function(response) {
                $scope.requesting = false;
                if (response.data.result) {
                    callback(response.data.payload);
                } else {
                    console.log(response.data.message ? response.data.message : 'error');
                }
            });
        };

        $scope.exportEcardsRecipients = function() {
            $scope.ajaxIt('export_ecards_recipients', {
            }, function(payload) {
                $scope.downloadLink(payload);
            });
        };

        window.exportEcardsRecipients = $scope.exportEcardsRecipients;

        $scope.exportSellers = function() {
            $scope.ajaxIt('export_sellers', {
                year: $scope.vm.team.years[$scope.vm.year].year,
                team: $scope.vm.team.slug
            }, function(payload) {
                $scope.downloadLink(payload);
            });
        };

        $scope.exportSales = function(which, year) {
            $scope.ajaxIt('export_sales', {
                year: year,
                id: (which == 'seller' ? $scope.vm.data.query[0].id :  $scope.vm.team.slug),
                which: which
            }, function(payload) {
                $scope.downloadLink(payload);
            });
        };

        $scope.getSales = function() {
            $scope.ajaxIt('get_sales', {
                id:  $scope.vm.data.query[0].id
            }, function(payload) {
                $scope.vm.sales = payload.sales;
            });
        };
    }
})();